import BaseService from "../shared/services/BaseService";
import CommonUtils from "@/utils/common-utils";
import {KEY_LOCAL_STORE} from "../utils/constants";
class SecureMailService extends BaseService {
    constructor() {
        super('secureMailService');
    }
    getSecureMailPath = 'secure-mail/get';
    getKeySecureMailPath = 'secure-mail/key';
    insertSecureMailPath = 'secure-mail/insert';
    uploadFilePath = 'attach/upload-attach';
    downloadFilePath = 'attach/download-attach';
    deleteFilePath = 'attach/delete-attach-mail';
    otpRefresh = 'otp/refresh';
    otpVerify = 'otp/verify';

    getSecureMail(form) {
        const url = `${this.baseURL}/${this.getSecureMailPath}`;
        return this.getRequestSecureMail(url, form);
    }
    getKeySecureMail(form) {
        const url = `${this.baseURL}/${this.getKeySecureMailPath}`;
        return this.getRequestSecureMail(url, form, false);
    }
    insertSecureMail(form) {
        const url = `${this.baseURL}/${this.insertSecureMailPath}`;
        return this.postRequestSecureMail(url, form, false);
    }

    uploadFile(form) {
        const url = `${this.baseURL}/${this.uploadFilePath}`;
        return this.postRequestSecureMail(url, form, false);
    }

    downloadFile(form) {
        const url = `${this.baseURL}/${this.downloadFilePath}`;
        return this.postRequestBlob(url, form, false);
    }
    deleteFile(form) {
        const url = `${this.baseURL}/${this.deleteFilePath}`;
        return this.postRequestSecureMail(url, form, false);
    }

    refreshOtp(form) {
        const url = `${this.baseURL}/${this.otpRefresh}`;
        return this.postRequestSecureMail(url, form, false);
    }
    verifyOtp(form) {
        const url = `${this.baseURL}/${this.otpVerify}`;
        return this.postRequestSecureMail(url, form, false);
    }



}
export default new SecureMailService();
